import React from 'react';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider } from '@mui/material/styles';
import constants from '../../utils/constants';
import InputAdornment from '@mui/material/InputAdornment';

const index = ({ className, mode, maxLength, disabled, id, name, value, onChange, help, design, onBlur, mandatory }) => {

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  const onFormatNumber = (e) => {
    onBlur(e);
  }

  //const inputWidth = value ? (value.length > 20 ? `${Math.min(value.length, 256)}ch` : '5px') : (name.length * 5);
  const inputWidth = value ? `${value.length}ch` : '0ch';
  const minWidth = name.length + "ch";

  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <TextField
          inputProps={{ maxLength: maxLength, readOnly: mode, style: { height: '1px', width: inputWidth, minWidth: minWidth, fontSize: "inherit", lineHeight: "inherit", letterSpacing: "0.01rem" }, }}
          label={design !== 'table' ? <span>
            {name}
            {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
          </span> : null}
          disabled={disabled}
          key={id}
          id={id}
          //type="number"
          InputLabelProps={{ shrink: true, style: { fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", marginTop: !value ? '-8px' : '' } }}
          variant="outlined"
          value={value}
          onChange={handleChange}
          onBlur={onFormatNumber}
          className={className ?? undefined}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                %
              </InputAdornment>
            ),
            inputProps: {
              style: { height: '1px', width: inputWidth, minWidth: minWidth, textAlign: 'right', fontSize: "inherit", fontWeight: '600', letterSpacing: "0.01rem" },
            },
          }}
        />
      </Tooltip>
    </ThemeProvider>
  )
}

export default index